import { render, staticRenderFns } from "./AddOrgDialog.vue?vue&type=template&id=3fa24f1a&"
import script from "./AddOrgDialog.vue?vue&type=script&lang=js&"
export * from "./AddOrgDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports